import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "content"]

  connect() {
    this.startAnimations()
    this.setupParallax()
  }

  startAnimations() {
    setTimeout(() => {
      if (this.hasImageTarget) {
        this.imageTarget.style.transition = "transform 1.6s cubic-bezier(0.16, 1, 0.3, 1), opacity 1.4s ease-out"
        this.imageTarget.style.transform = "translateX(0) scale(1)"
        this.imageTarget.style.opacity = "1"
      }

      if (this.hasContentTarget) {
        const elements = this.contentTarget.querySelectorAll(".gsap-fade")
        elements.forEach((el, index) => {
          setTimeout(() => {
            el.classList.add("animated")
          }, 300 + (index * 120))
        })
      }
    }, 50)
  }

  setupParallax() {
    let ticking = false

    const handleScroll = () => {
      if (!ticking && this.hasImageTarget) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY
          const sectionHeight = this.element.offsetHeight

          if (scrollY < sectionHeight) {
            this.imageTarget.style.transform = `translateY(${scrollY * 0.03}px)`
          }
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
  }

  scrollToSection(event) {
    event.preventDefault()

    const href = event.currentTarget.getAttribute("href")
    const targetId = href.replace("#", "")
    const element = document.getElementById(targetId)

    if (element) {
      const headerHeight = 80
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: "smooth"
      })
    }
  }
}
